import React from 'react'
import Footer from '../Component/Footer'
import NewRelease from '../Component/NewRelease'
import Header from '../Component/Header'
import HomeCategories from '../Component/HomeCategories'
import ContentDownload from '../Component/ContentDownload'
import { Grid, Container } from '@mui/material'
import Slideshow from '../Component/Slideshow'
import SubFooter from '../Component/SubFooter'
export default function Home() {
  return (
    <Grid container direction={'column'}>
      <Header />
      <Slideshow />
      <Container maxWidth='xl'>
        <Grid item xs={12} md={12} lg={12}>
          <NewRelease />
          <HomeCategories />
        </Grid>
      </Container>
      <ContentDownload />
      <Footer />
      <SubFooter />
    </Grid>
  )
}
